import { render, staticRenderFns } from "./Replica.vue?vue&type=template&id=3f530738"
import script from "./Replica.vue?vue&type=script&lang=js"
export * from "./Replica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports